class Controller {
  constructor($injector) {
    "ngInject";

    this.Rating = $injector.get("Rating");
    this.sections = $injector.get("Sections").bookingsSections;
  }

  $onInit() {
    this.Rating.daily().$promise.then((response) => {
      this.dailyData = response;
    });

    this.Rating.weekly().$promise.then((response) => {
      this.weeklyData = response;
    });

    this.Rating.monthly().$promise.then((response) => {
      this.monthlyData = response;
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/ratings/ratings.controller.js